import React from 'react'
import { LabelForRoute, Link } from '@morningtrain/react-navigation'
import * as Auth from '@morningtrain/react-auth'
import TabletSidebarMenuItem from 'ui/navigation/TabletSidebarMenuItem'

function TabletMenuItem (props) {
  const handleOnClick = (e) => {
    if (typeof props.onClick === 'function') {
      props.onClick(e.target)
    }
  }

  const Item = (
    <Link className='block group' route={props.route} onClick={handleOnClick}>
      <TabletSidebarMenuItem
        active={props.active}
        text={<LabelForRoute label={props.label} route={props.route} />}
        svgIcon={props.svgIcon}
      />
    </Link>
  )

  if (props.route) {
    return (
      <Auth.Can permission={props.route}>
        {Item}
      </Auth.Can>
    )
  }

  return Item
}

export default TabletMenuItem
